<template>
  <section class="feedback" v-if='step == 1'>
    <header-com/>
    <section class="wrap" :class="{'animation':showAll}" @click="showAll=true" >
      <textarea class="" placeholder="你有神马要吐槽的？" maxlength="200" v-model="content"></textarea>
      <div class="num grey9 f14">{{content.length}}/200</div>
      <!--<transition name="van-fade">-->
      <section class="uploadWrap "  v-show="showAll">
        <ul  class="imageList">
          <li v-for="(item,index) in imagesUrls" :key="index">
            <img :src="item" alt="" />
            <van-icon name="close" class="delete-img" @click="removeImg(index)" />
          </li>
          <li v-if="imagesUrls.length<3">
            <upload-com @on-change='uploadChange'/>
          </li>
        </ul>
      </section>
      <!--</transition>-->
    </section>
    <transition name="van-fade">
      <div class="g-fixed-bottom t_right"  v-show="showAll"  >
        <button class="primary" @click="commit">提交</button>
      </div>
    </transition>
  </section>

  <section v-else>
    <header-com/>
    <img src="/images/order/paySuc.png" alt="" class='imgs'/>
    <!-- <div class='thank'>谢谢</div> -->
    <div class='suclog'>感谢您的反馈，包大人已经收到了您的反映内容</div>
    <div class='suclog'>大人会安排工作人员尽快和您取得联系</div>
    <div class='suclog'>包拯服务热线：4000520618 期待您的来电</div>
  </section>
</template>

<script>
  import { Toast ,Dialog} from 'vant';
  import myApi from '@/axios/my'
   import zhugeObj from '@/assets/js/track'
  export default {
    name: 'feedback',
    components: {},
    data () {
      return {
        showAll: false,
        imagesUrls: [],
        imgList: [],
        content: '',
        max: 3,
        step : 1,
      }
    },
    watch: {},
    computed: {},
    created () {
    },
    mounted () {
      尺寸说明页
    },
    methods: {
      uploadChange(data){
        this.imagesUrls.push(data.template);
        this.imgList.push(data.path);
      },
      commit () {
        if (!this.content) {
          Toast('内容不能为空喔~')
          return;
        }
        myApi.feedBack({
          description :this.content,
          picList:this.imgList
        }).then(res=>{
          // Toast('反馈成功');
          this.step = 2;
          // this.$router.back()
        })
      },
      removeImg (index) {
        this.imagesUrls.splice(index,1);
        this.imgList.splice(index,1);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .suclog{
    font-size: 30px;
    color:#999999;
    text-align: center;
    margin-top:20px; 
    padding-left:50px;
    margin-right: 50px;
    line-height: 50px;
  }
  .thank{
    font-size: 40px;
    color:#000;
    text-align: center;
    margin-top:80px; 
  }
  .imgs{
    width: 40%;
    margin-left:30%; 
    margin-bottom:120px;
    margin-top: 30%;
  }
  .feedback{
    padding: 100px 20px 0;
    .wrap{
      box-sizing: border-box;
      height: 128px;
      background: #fff url("/images/my/feedback_icon_01.png") no-repeat 176px 38px;
      background-size: 48px;
      border-radius:$base-radius;
      box-shadow: $base-shadow;
      padding: 20px;
      position: relative;
      .num{
        height: 0;opacity: 0;
        line-height: 34px;
        position: absolute;
        right: 40px;
        top:294px
      }
      textarea{
        background: $white-color;
        width: 324px;height: 50px;
        margin: 18px 0 0 224px;
        border-radius:$base-radius;
        font-size:28px;line-height:36px;
      }
      textarea::-webkit-input-placeholder{
        font-size: 36px;line-height:50px;color: $light-grey;
      }
      &.animation{
        animation: wrapAnimation .8s ease-in-out forwards;
        textarea{animation: textareaAnimation .5s ease-in-out forwards;padding: 20px}
        textarea::-webkit-input-placeholder{font-size:28px;line-height:36px; }
        .num{animation: show .5s .8s ease-in-out forwards}
        .uploadWrap{animation: show .5s .8s ease-in-out forwards}
      }
    }
    .uploadWrap{
      opacity: 0;
      animation-delay: 2s;
      animation-duration:.3s;
      ul{
        display: flex;
      }
      li{
        width: 190px;
        height: 190px;
        position: relative;
        margin-right: 40px;
        img{
          width: 100%;
          height: 100%;
          &.delete-img{
            font-size: 40px;
            position: absolute;
            top: 0;
            right: 0;
          }
        }
      }
    }
    @keyframes wrapAnimation {
      0%{height: 128px;background-image: none}
      100%{height:630px;background-image: none}
    }
    @keyframes textareaAnimation {
      0%{margin: 18px 0 0 224px;background: $white-color}
      50%{width: 630px;height:50px;margin: 18px 0  60px 0;background: $border-color}
      100%{width: 630px;height: 260px;margin: 18px 0 60px 0;background: $border-color}
    }
    @keyframes show {
      0%{opacity: 0}
      100%{opacity: 1}
    }
  }
</style>
